import { Phone, Mail, MapPin, Instagram, Facebook, Youtube } from "lucide-react";
import { BRAND, PUNE_AREAS } from "@/lib/site-data";

export default function Footer() {
  return (
    <footer className="bg-brand-pineDark text-white/80" data-testid="footer">
      {/* Areas marquee */}
      <div className="border-y border-white/10 py-6 overflow-hidden">
        <div className="flex gap-10 whitespace-nowrap animate-marquee">
          {[...PUNE_AREAS, ...PUNE_AREAS].map((a, i) => (
            <span key={i} className="font-serif text-2xl italic text-white/50">
              {a} <span className="text-brand-clay not-italic mx-4">·</span>
            </span>
          ))}
        </div>
      </div>

      <div className="container-site py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo.png" alt={BRAND.name} className="h-12 w-auto brightness-0 invert" />
            <div className="leading-tight">
              <div className="font-serif text-2xl text-white">
                Home Visit <span className="text-brand-clay">Dental Treatment</span>
              </div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-white/50 mt-1">
                Pune & PCMC City
              </div>
            </div>
          </div>
          <p className="max-w-md leading-relaxed text-white/60">
            Home-visit dentistry for Pune — built for seniors, bed-ridden
            patients, busy families, and everyone who'd rather skip the clinic.
          </p>
          <div className="flex flex-wrap gap-3 mt-6">
            {[
              {
                Icon: Instagram,
                url: BRAND.social.instagram,
                label: "Instagram",
                gradient: "bg-gradient-to-tr from-[#feda75] via-[#fa7e1e] via-40% to-[#d62976]",
              },
              {
                Icon: Facebook,
                url: BRAND.social.facebook,
                label: "Facebook",
                gradient: "bg-[#1877F2]",
              },
              {
                Icon: Youtube,
                url: BRAND.social.youtube,
                label: "YouTube",
                gradient: "bg-[#FF0000]",
              },
            ]
              .filter((s) => s.url)
              .map(({ Icon, url, label, gradient }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  data-testid={`social-${label.toLowerCase()}`}
                  className={`group relative inline-flex items-center gap-2 pl-2 pr-4 py-2 rounded-full bg-white/5 border border-white/15 hover:border-white/40 hover:bg-white/10 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-black/20`}
                >
                  <span
                    className={`w-9 h-9 rounded-full ${gradient} flex items-center justify-center text-white shadow-md transition-transform duration-300 group-hover:scale-110`}
                  >
                    <Icon size={16} strokeWidth={2} />
                  </span>
                  <span className="text-sm font-medium text-white/90 group-hover:text-white">
                    {label}
                  </span>
                </a>
              ))}
          </div>
        </div>

        <div>
          <h4 className="font-serif text-lg text-white mb-4">Reach us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone size={14} className="mt-1 text-brand-clay" />
              <a href={`tel:${BRAND.phoneRaw}`} className="hover:text-white">
                {BRAND.phone}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={14} className="mt-1 text-brand-clay" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-white">
                {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-1 text-brand-clay" />
              <span>{BRAND.address}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg text-white mb-4">Quick links</h4>
          <ul className="space-y-2 text-sm">
            <li><a className="hover:text-white" href="#services">Services</a></li>
            <li><a className="hover:text-white" href="#process">How it works</a></li>
            <li><a className="hover:text-white" href="#about">About us</a></li>
            <li><a className="hover:text-white" href="#faq">FAQs</a></li>
            <li><a className="hover:text-white" href="#booking">Book a visit</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <div className="container-site flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} {BRAND.name} · Pune. All rights reserved.</p>
          <p>Crafted with care for every Pune home.</p>
        </div>
      </div>
    </footer>
  );
}
